<template>
  <component :is="containerTag" :class="['trans_box', containerClass]">
    <slot></slot>
  </component>
</template>

<script setup>
defineProps({
  containerTag: {
    type: String,
    default: 'div',
  },
  containerClass: {
    type: String,
    default: '',
  },
});
</script>
